import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import {Jumbotron, Grid, Row, Col, Image, Button, Form, FormGroup, FormControl, ControlLabel, Checkbox } from 'react-bootstrap';
import './Register.css';

export default class Register extends Component {
    render() {
        return (
            <div className="container-reg">
                <Form>
                <Row>
                <FormGroup controlId="username">
                    <ControlLabel>Username</ControlLabel>{' '}
                    <FormControl type="text" />
                </FormGroup>{' '}
                </Row>
                <Row>
                <FormGroup controlId="name">
                    <ControlLabel>Firstname</ControlLabel>{' '}
                    <FormControl type="text" />
                    {' '}
                    <ControlLabel>Name</ControlLabel>{' '}
                    <FormControl type="text" />
                </FormGroup>{' '}
                </Row>
                <Row>
                <FormGroup controlId="email">
                    <ControlLabel>Email</ControlLabel>{' '}
                    <FormControl type="email" />
                </FormGroup>{' '}
                </Row>
                <Row>
                <FormGroup controlId="telnumber">
                    <ControlLabel>Telephone Number </ControlLabel>{' '}
                    <FormControl type="number" />
                </FormGroup>{' '}
                </Row>
                <Row>
                <FormGroup controlId="password">
                    <ControlLabel>Password</ControlLabel>{' '}
                    <FormControl type="password" />
                </FormGroup>{' '}
                </Row>
                <Row>
                <Checkbox required><Link to="/agb"><div className="agb">Ich akzeptiere die Teilnahmebedingungen</div></Link></Checkbox>
                <Button type="submit" className="btn-sample" onClick={() => this.props.history.push('/game')}>Send invitation</Button>
                </Row>
                </Form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Register.jsx